/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-anonymous-default-export */
import React, { Fragment, useContext, useEffect, useState,  memo, useCallback, useReducer } from "react";

// Utils
import { _O, _CHECK } from "../../modules/utils";
// UI
import { ContainerNew, MenuNone, CloseMenu } from "../Layout";

import _T_ICON from "../../resources/images/icon/icon_gray_certifi.png";
import { AppContext } from "../../components/AppProvider";
import { getCookie } from "../../modules/utils/cookie";
import { userHabit } from "../../modules/utils/UserHabit";
import { NativeAction } from "../../modules/utils/HandleWs";

export default (props) => {
    // const webSocketUrl = "ws://172.30.1.161:8080";
    const {userinfo, cfg, phonecfg} = useContext(AppContext);
    
    const gotoRightHandle = () => {
        _O.Open("/");
    }

    const handleSocket = () => {
        let goToUrl;
        $("#userToken").val(userinfo.userToken);

        if(userinfo.userToken) {
            goToUrl = 'certificateToUpdate/';
        } else {
            // IOS에서 WS연동이 안되는 중(https일때)
            if(phonecfg.phoneOS === "ANDROID") {
                goToUrl = 'certificate2/';
            } else {
                goToUrl = 'certificate2/';
            }
        }

        $.get(cfg.webUrl + goToUrl, function (data) {
            $("#enc_data").val(data.encData);

            document.form_certificate.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
            document.form_certificate.target = "_self";
            document.form_certificate.submit();
        })
    }

    useEffect(() => {
        userHabit(phonecfg, 'CT100');
        NativeAction(phonecfg, "statusColor", "#A5AEE4");
    }, [])
    return (
        <Fragment>
            <ContainerNew Title={ '본인 인증' } dark={true} leftMenu={MenuNone} rightMenu={CloseMenu} gotoRightHandle={gotoRightHandle}>
                <form name='form_certificate' method="post">
                    <input type="hidden" name="m" value="checkplusSerivce" />
                    <input type="hidden" name="EncodeData" id='enc_data' />
                    <input type="hidden" name="param_r1" id='userToken' />
                    {/* <input type="hidden" name="param_r2" value="mobile" /> */}
                    <input type="hidden" name="param_r2" value={phonecfg.phoneOS} />
                    <input type="hidden" name="param_r3" id="signUpChannel" value={getCookie('signUpChannel')}/>
                </form>
                <div className="login-pw-box">
                
                    <div className="pw-inp-box">
                        <span>본인을 인증해주세요.</span>

                        <div className="certifi-box">
                            <img src={_T_ICON} alt="본인 인증 아이콘" />
                            <div>
                                <span>최초 1회 본인 인증이 필요합니다. </span>
                                <p>
                                    본인인증시 수집된 개인정보는 서비스외에 다른용도로<br/>
                                    사용되지 않습니다.
                                </p>
                            </div>
                        </div>

                        <div className="btn">
                            <a href={void 0} onClick={(e)=>handleSocket()}>본인 인증하기</a>
                        </div>
                    </div>

                </div>

            </ContainerNew>

        </Fragment>
    );
};